import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import headerImage from '../assets/images/header.png';

const SCHOOL_ID_RE =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

function getPublicApiBase() {
  const env = process.env.REACT_APP_API_BASE_URL;
  if (env) return String(env).replace(/\/$/, '');
  if (process.env.NODE_ENV === 'production') {
    return 'https://api.gethomecrowd.com/api';
  }
  return 'http://localhost:8000/api';
}

export function readSchoolId(searchParams) {
  const raw = String(
    searchParams.get('schoolId') ||
      searchParams.get('schoolID') ||
      searchParams.get('school_id') ||
      '',
  )
    .trim()
    .replace(/^\/+|\/+$/g, '');
  return SCHOOL_ID_RE.test(raw) ? raw : '';
}

function pickAccent(config) {
  return String(
    (config &&
      (config.inApp ||
        config.inAppColor ||
        config.buttonColor ||
        config.linkColor ||
        config.accentColor)) ||
      '',
  ).trim();
}

const EMPTY_BRANDING = {
  isSchool: false,
  logoUrl: headerImage,
  brandName: 'HomeCrowd',
  style: undefined,
};

export function useSchoolLegalBranding() {
  const [searchParams] = useSearchParams();
  const schoolId = readSchoolId(searchParams);
  const [branding, setBranding] = useState(EMPTY_BRANDING);

  useEffect(() => {
    if (!schoolId) {
      setBranding(EMPTY_BRANDING);
      return undefined;
    }
    let cancelled = false;
    fetch(
      getPublicApiBase() +
        '/school/merchants-page-config/' +
        encodeURIComponent(schoolId) +
        '/',
    )
      .then((res) => {
        if (!res.ok) throw new Error('branding fetch failed');
        return res.json();
      })
      .then((config) => {
        if (cancelled || !config) return;
        const logoUrl = String(config.headerLogoUrl || config.logoUrl || '').trim();
        const brandName = String(
          config.rewardsTitle || config.schoolName || config.abbreviation || '',
        ).trim();
        const accent = pickAccent(config);
        setBranding({
          isSchool: true,
          logoUrl: logoUrl || headerImage,
          brandName: brandName || 'HomeCrowd',
          style: accent ? { '--legal-link': accent } : undefined,
        });
      })
      .catch(() => {
        if (!cancelled) setBranding(EMPTY_BRANDING);
      });
    return () => {
      cancelled = true;
    };
  }, [schoolId]);

  return branding;
}

export function SchoolLegalHeader({ branding }) {
  const brand = branding || {};
  return (
    <div className="auth-header">
      <img
        src={brand.logoUrl || headerImage}
        alt={brand.brandName || 'HomeCrowd'}
        className="auth-logo"
      />
      {brand.isSchool ? (
        <div className="legal-powered-by">
          {/* Lowercased in CSS, matching the embed, so the casing is decided in
              one place rather than differing between the two apps. */}
          <span className="legal-powered-by-label">POWERED BY</span>
          {/* A masked span rather than an <img>: the wordmark is tinted via
              background-color so it renders the exact reference colour instead
              of whatever the PNG happens to be. */}
          <span
            className="legal-powered-by-logo"
            role="img"
            aria-label="Homecrowd"
          />
        </div>
      ) : null}
    </div>
  );
}
